// 联系我们（移动端）
<template>
  <div class="cmain">
    <mheader></mheader>
    <div class="topimg"></div>
    <div class="center">
      <h1>
        <span class="bluue">联系我们</span> CONTACT US
      </h1>
      <div class="lxwm">
        <div class="map">
          <el-amap :center="center" :zoom="zoom" id="container" :events="events">
            <el-amap-marker :position="center" :label="label"></el-amap-marker>
          </el-amap>
        </div>
        <div class="right">
          <!-- <p>
            <span>
              <img src="../../assets/img/icon/座机@2x.png" class="oneImg" />
            </span>
            业务咨询：0371-65353150
          </p> -->
          <p>
            <span>
              <img src="../../assets/img/icon/手机@2x.png" class="twoImg" />
            </span>
            客服电话：0371-65353150
          </p>
          <p>
            <span>
              <img src="../../assets/img/icon/地址@2x.png" class="threeImg" />
            </span>
            地址：河南省郑州市郑东新区郑开大道89号河南建设大厦
          </p>
        </div>
      </div>

      <div class="message">
        <h1>
          <span class="bluue">在线留言</span> MESSAGE
        </h1>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="3rem"
          class="demo-ruleForm"
        >
          <el-form-item label="姓名" prop="name">
            <el-input v-model="ruleForm.name" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="phone">
            <el-input v-model="ruleForm.phone" placeholder="请输入电话"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="ruleForm.email" placeholder="请输入邮箱"></el-input>
          </el-form-item>
          <el-form-item label="留言">
            <el-input type="textarea" v-model="ruleForm.desc" class="msg"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')" class="submitt">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <mfooter></mfooter>
  </div>
</template>

<script>
import mheader from "../../components/mobileHF/mHeader";
import mfooter from "../../components/mobileHF/mFooter";
export default {
  props: {},
  data() {
    return {
      center: [113.862161, 34.772913],
      zoom: 14,
      label: {
        content: "河南省建协工程咨询有限公司",
        offset: [10, 12],
      },
      ruleForm: {
        name: "",
        phone: "",
        email: "",
        desc: "",
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [{ required: true, message: "请输入电话", trigger: "blur" }],
        email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
      },
    };
  },
  mounted() {
    if (this.isMobile()) {
      this.$router.replace("/mContact"); //移动端跳转路由
    } else {
      this.$router.replace("/serve"); //Pc端跳转路由
    }
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert('submit!');
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 初始化地图
    initMap(map) {
      var map = new AMap.Map("container", {
        zoomEnable: true, //是否禁止缩放
        zoom: 12, //缩放比例
        dragEnable: false, //禁止拖动
        cursor: "hand", // 鼠标在地图上的表现形式，小手
      });
      // 初始化工具条
      map.plugin(["AMap.ToolBar"], function () {
        map.addControl(new AMap.ToolBar());
      });
    },
  },
  components: {
    mheader,
    mfooter,
  },
};
</script>

<style scoped lang="less">
.cmain {
  .topimg {
    width: 100%;
    height: 8.9rem;
    background: url("../../assets/img/mobile/mBanner/联系.png") 0 0 no-repeat;
    background-size: 100%;
  }
  .center {
    width: 100%;
    padding: 0rem 0.6rem;
    box-sizing: border-box;
    overflow: hidden;
    margin-bottom: 1rem;
    h1 {
      span {
        opacity: 1;
        font-size: 1rem;
        font-family: Microsoft YaHei Bold, Microsoft YaHei Bold-Bold;
        font-weight: 700;
        text-align: center;
        color: #4279db;
        line-height: 0.75rem;
        letter-spacing: 0.02rem;
        margin-bottom: 0.6rem;
      }
      opacity: 1;
      font-size: 1rem;
      font-family: Microsoft YaHei Bold, Microsoft YaHei Bold-Bold;
      font-weight: 700;
      text-align: center;
      color: black;
      line-height: 1rem;
      letter-spacing: 0.1rem;
      margin-top: 1rem;
      margin-bottom: 1rem;
    }
    .title {
      opacity: 1;
      font-size: 1rem;
      font-family: Microsoft YaHei Bold, Microsoft YaHei Bold-Bold;
      font-weight: 700;
      text-align: center;
      color: #4279db;
      line-height: 1.4rem;
      margin: 1rem 0rem;
    }
    .lxwm {
      width: 100%;
      height: 13.04rem;
      position: relative;
      margin-bottom: 1.14rem;
      .map {
        width: 100%;
        height: 10rem;
        background: brown;
        position: absolute;
        top: 0rem;
        left: 0rem;
      }
      .right {
        width: 100%;
        height: 8rem;
        position: absolute;
        top: 11rem;
      }
      p {
        width: 96%;
        height: 1.3rem;
        opacity: 1;
        font-size: 0.7rem;
        font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
        font-weight: 400;
        text-align: justifyLeft;
        color: #333333;
        line-height: 1.5rem;
        letter-spacing: 0.02rem;
        padding-left: 1.3rem;
        position: relative;
        span {
          display: block;
          width: 0.6rem;
          height: 0.5rem;
          position: absolute;
          left: 0rem;
          top: 0.1rem;
          .oneImg {
            width: 0.85rem;
            height: 0.7rem;
          }
          .twoImg {
            width: 0.53rem;
            height: 0.73rem;
            margin-left: 0.14rem;
          }
          .threeImg {
            width: 0.6rem;
            height: 0.73rem;
            margin-left: 0.11rem;
          }
        }
      }
    }
    .message {
      margin-bottom: 1.09rem;
      margin-top: 9rem;
      h1 {
        span {
          opacity: 1;
          font-size: 1rem;
          font-family: Microsoft YaHei Bold, Microsoft YaHei Bold-Bold;
          font-weight: 700;
          text-align: center;
          color: #4279db;
          line-height: 0.75rem;
          letter-spacing: 0.02rem;
          margin-bottom: 0.6rem;
        }
        opacity: 1;
        font-size: 1rem;
        font-family: Microsoft YaHei Bold, Microsoft YaHei Bold-Bold;
        font-weight: 700;
        text-align: center;
        color: black;
        line-height: 0.75rem;
        letter-spacing: 0.05rem;
      }
    }
  }
}
</style>
